import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { getSeatMapsResultIdentity, parseSeatMaps } from '@/lib/seatmap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { SeatmapTypes } from '../actions/actions.types'

type SeatmapState = ApplicationState['seatmaps']

const emptySeatmapState: SeatmapState = {
	flights: new ImmutableMap(),
}

function seatmapReducer(state: SeatmapState = emptySeatmapState, action: IAction): SeatmapState {
	switch (action.type) {
		case SeatmapTypes.GetForFlight.UPDATE:
		case SeatmapTypes.GetForFlight.SUCCESS:
			return {
				...state,
				flights: state.flights.set(
					getSeatMapsResultIdentity(action.requestPayload),
					parseSeatMaps(action.payload.seat_maps, action.requestPayload?.vendor_key),
				),
			}
	}
	return state
}

export default seatmapReducer
